<template>
    <div>
        <el-tag :key="tag" v-for="tag in selectedTags" :disabled="disabled" closable :disable-transitions="false" @close="handleClose(tag)">
            {{ tag }}
        </el-tag>
        <el-input class="input-new-tag" :class="{ 'no-tag': selectedTags.length === 0 }"
             v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="mini"
            @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm" placeholder="Username..">
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput"
            :class="{ 'no-tag': selectedTags.length === 0 }">+ Enter username</el-button>
    </div>
</template>

<style>
.el-tag+.el-tag {
    margin-left: 10px;
}

.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
.input-new-tag.no-tag {
    margin-left: 0;
}
.button-new-tag.no-tag {
    margin-left: 0;
}
</style>

<script>
export default {
    props: {
        value: {
            type: Array,
            default() { return [] }
        },
        disabled: {
            type: Boolean,
            default() { return false }
        }
    },
    data() {
        return {
            selectedTags: this.value,
            inputVisible: false,
            inputValue: ''
        };
    },
    mounted() {
       this.selectedTags = this.value;
    },
    methods: {
        handleClose(tag) {
            this.selectedTags.splice(this.selectedTags.indexOf(tag), 1);
            this.$emit('input', this.selectedTags);
        },

        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.selectedTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
            this.$emit('input', this.selectedTags);
        }
    }
}
</script>
